import { h } from '@atomify/jsx';
import { MapTheme } from '@bpd-library/types';
import { ButtonRound } from '@source/components/atoms/button-round/button-round';
import { BLUE, extendMapTheme, HOVER, WHITE } from '@utilities/map';

export const THEME: MapTheme = extendMapTheme({
    polygon: {
        settings: [
            {
                variant: 'wishlist',
                normal: {
                    fill: [...BLUE, 0.4],
                    stroke: [...WHITE, 1],
                },
                hover: HOVER,
            },
        ],
    },
    pointer: {
        settings: [
            {
                variant: 'heartIcon',
                disablePointerEvents: true,
                createElement: () => (
                    <ButtonRound
                        ariaLabel="Wishlist icon"
                        size="small"
                        svg="icons-heart"
                        variant="light"
                        classes="wishlist__map-icon"
                    />
                ),
            },
        ],
    },
});
